export default __webpack_public_path__ + "static/twinfalls-ac9e2c60231c0ebdfc810ce4afd85510.jpg";